<template>
  <div>
    <el-dialog width="230" center title="选择路径" :visible.sync="dialogVisible" append-to-body>
      <el-tree ref="moveTree" :props="props" :data="treeData"></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button type="danger" @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import folderApi from "@/api/modules/basicData/folder";
import Linq from 'linq';
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      treeData:[],
      dialogVisible: false,
      props: {
        label: "NODENAME",
        children: "children",
        isLeaf: "isLeaf"
      }
    };
  },
  computed: {
    ...mapState({
      copyList: state => state.folder.copyList,
      selectionList: state => state.folder.selectionList,
      folderState: state => state.folder.folderState,
      Person: state => state.folder.Person,
      permissionType: state => state.folder.permissionType,
    })
  },
  methods: {
    loadNode(node, resolve) {
      this.node = node;
      this.resolve = resolve;
      if (node.level === 0) {
        this.GetTaskTreePathList(
          {
            IsRoot: true,
            PermissionType :this.folderState==1? this.permissionType:0
          },
          resolve
        );
      }
      if (node.level >= 1) {
        //return resolve([]);
        console.log("node", node.data.NODEID);
        this.GetTaskTreePathList(
          {
            NodeId: node.data.NODEID,
            IsRoot: false
          },
          resolve
        );
      }
    },
    refreshData() {
      //手动调用加载数据方法
      // this.node.childNodes=[];
      // this.loadNode(this.node, this.resolve);
      this.GetMyTaskTreePath()
    },
    OpenDialog() {
      let _this = this;
      this.dialogVisible = true;
      // if (this.node) {
        this.refreshData();
      // }
    },
    close() {
      this.dialogVisible = false;
    },
    save() {
      let moveInfo = this.$refs.moveTree.getCurrentNode();
      console.log("moveInfo", moveInfo);
      if (moveInfo) {
        let pasteList = this.copyList;
        pasteList.forEach(item => {
          item.PNODEID = moveInfo.NODEID;
          item.PNODENAME = moveInfo.NODENAME;
          item.PNODETYPE = moveInfo.NODETYPE;
          item.CREATETIME = new Date(item.CREATETIME);

          item.PRELATIONID = moveInfo.RELATIONID,
          item.PRELATIONTYPE=moveInfo.RELATIONTYPE,

          item.RELATIONCREATETIME = new Date(item.RELATIONCREATETIME);
        });
        this.$store.dispatch("UpdateTaskTreePath", pasteList);
        this.close();
      } else {
        this.$message({
          message: "请选择节点",
          center: true,
          type: "warning"
        });
      }
    },
    GetTaskTreePathList(paras, resolve) {
      paras.Person = this.Person;
      folderApi.GetTaskTreePathList(paras).then(res => {
        if (res && res.length > 0) {
          res =  Linq.from(res).orderByDescending(item => item.CREATETIME).toArray();
          if(paras.PermissionType!==2){
            res = res.filter(item => item.NODETYPE == 3);
          }
          // res = res.filter(item => item.NODETYPE == 3);
          let copylist = this.copyList.filter(item => item.NODETYPE == 3);
          // let nodeids = copylist.map(item => {
          //   return item.NODEID;
          // });
          copylist.forEach(v=>{
            res = res.filter(p=>p.NODEID!=v.NODEID)
          })
          // console.log("nodeids", nodeids);
          // res = res.filter(p => nodeids.indexOf(p.NODEID) < 0);

          // state.taskGroupList = res;
          res.forEach(item => {
            item.isLeaf = item.CHILDRENCOUNT == 0;
          });
          return resolve(res);
        }else{
          return resolve([]);
        }
      });
    },
    GetMyTaskTreePath(){
      folderApi.GetMyTaskTreePath(this.Person).then(res => {
        if (!res) {
          this.treeData = []
        }
        else {
          this.treeData = res.find(item=>item.NODENAME=='团队').children;;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>